<template>
  <div class="main-content main-content_vertical">
    <div class="wrapper">
      <div class="h1 h1-mob-lg">{{ $t('subscriptions.select_your_level') }}</div>
      <div class="main-content__row">
          <div class="main-content__col main-content__col_1">
              <ul class="sponsorship-level">
                  <sponsorship-level-item
                      v-for="level in $store.getters.sponsorshipLevels" :key="level.ID"
                      :level="level"
                      >
                  </sponsorship-level-item>
              </ul>
          </div>
      </div>
      <div class="link-back-row">
        <router-link to="/subscriptions" class="black-link" v-if="$store.getters.currentSubscription">{{$t('subscriptions.go_back')}}</router-link>
        <router-link to="/" class="black-link" v-else>{{$t('sent.go_back')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>

import SponsorshipLevelItem from "@/components/SponsorshipLevelItem";

export default {
  name: "SubscriptionsSelector",
  components: {
    SponsorshipLevelItem,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.getters.subscriptionsEnabled || !vm.$store.getters.authenticated) {
        next('/');
      } else if (vm.$store.getters.currentSubscription?.inPayment) {
        next('/subscriptions');
      }  else {
        next();
      }
    });
  },
};
</script>
